// extracted by mini-css-extract-plugin
export default {"configurableInput":"configurableInputks4Bf","inputLabel":"inputLabelKMuo1"};